import axiosInstance from "./api";
import TokenService from "./token.service";
import AuthService from "./auth.service";
import Xss from 'xss'
const xss = Xss;

const setup = (store) => {
  // ========================================
  // CONFIGURAR TIMEOUT DO AXIOS
  // ========================================
  axiosInstance.defaults.timeout = 35000;  // 35 segundos

  // Request interceptor
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = TokenService.getLocalAccessToken();
      const lang = TokenService.getLanguage();
      if(config.data)
        config.data = JSON.parse(xss(JSON.stringify(config.data)));
        
      if (token) {
        if(config.url.indexOf("auth/refresh") >= 0)
          config.headers["Authorization"] = 'Bearer ' + TokenService.getLocalRefreshToken();
        else
          config.headers["Authorization"] = 'Bearer ' + token;
      }

      if(lang)
        config.headers["x-custom-lang"] = lang;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor COM RETRY
  axiosInstance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;

      // RETRY para Erros 5xx (500-599) e 429
      const status = err.response?.status;
      const isRetryableError = 
        (status >= 500 && status < 600) || status === 429;                      
      
      if (isRetryableError) {
        // Inicializar contador de retry
        originalConfig.__retryCount = originalConfig.__retryCount || 0;
        
        // Se ainda não tentou 3 vezes
        if (originalConfig.__retryCount < 3) {
          originalConfig.__retryCount++;
          
          // Aguardar 1s antes de tentar novamente
          await new Promise(resolve => setTimeout(resolve, 1000));
          
          // Tentar novamente
          return axiosInstance(originalConfig);
        }
        
        // Se já tentou 3 vezes, falha definitivamente
        console.error('Retry Failed >3 retries');
      }
      
      if (err.response?.status === 401)
        store.dispatch('auth/logout');

      return Promise.reject(err);
    }
  );
};

export default setup;